import { render, staticRenderFns } from "./StartProcessButton.vue?vue&type=template&id=3aff6966"
import script from "./StartProcessButton.vue?vue&type=script&lang=js"
export * from "./StartProcessButton.vue?vue&type=script&lang=js"
import style0 from "./StartProcessButton.vue?vue&type=style&index=0&id=3aff6966&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports